import { z } from "zod";

const safeHeaderValueSchema = z.string().trim().min(1).max(255);

export const correlationIdSchema = safeHeaderValueSchema.regex(
  /^[A-Za-z0-9][A-Za-z0-9._:-]*$/,
  "Invalid correlation ID",
);

export const idempotencyKeySchema = safeHeaderValueSchema.regex(
  /^[\x21-\x7E]+$/,
  "Idempotency key must contain visible ASCII characters only",
);

export const requestControlHeadersSchema = z
  .object({
    "x-correlation-id": correlationIdSchema.optional(),
    "idempotency-key": idempotencyKeySchema.optional(),
  })
  .strict();

export type RequestControlHeaders = z.infer<typeof requestControlHeadersSchema>;

export const responseControlHeadersSchema = z
  .object({
    "x-correlation-id": correlationIdSchema,
  })
  .strict();

export type ResponseControlHeaders = z.infer<typeof responseControlHeadersSchema>;

